import { render } from "./NomenclatoareCRM.vue?vue&type=template&id=e2a67a5c&scoped=true&ts=true"
import script from "./NomenclatoareCRM.vue?vue&type=script&lang=ts"
export * from "./NomenclatoareCRM.vue?vue&type=script&lang=ts"

import "./NomenclatoareCRM.vue?vue&type=style&index=0&id=e2a67a5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a67a5c"]])

export default __exports__